import camelCaseToSnakeCase from "../camelCaseToSnakeCase";

export const buildSortParam = (sortBy: [{ id: string; desc: boolean }]) => {
  return `${sortBy[0].desc ? "-" : ""}${camelCaseToSnakeCase(sortBy[0].id)}`;
};

export default buildSortParam;
